import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Message from 'rc-message';

import { deleteOne } from 'api/speciesApi';
import Permissions from 'react-redux-permissions';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import { Col, Row } from 'reactstrap';
import { get } from 'lodash';
import moment from 'moment';
import AreaManagement from '../AreaManagement';
import { COLOR } from 'config';
import UploadImageComponent from 'components/elements/upload-image';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ItemValue = styled.div`
  font-size: 14px;
  .required {
    color: #660000;
    font-weight: 700;
  }
`;

const SpeciesInfo = styled.div`
  display: flex;
`;

const ImagePart = styled.div`
  margin-left: 5px;
`;

const InfoPart = styled.div`
  margin-left: 20px;
  width: calc(100% - 150px);
`;

const RowValue = (props) => {
  return (
    <ItemValue>
      <Row>
        <Col md={1} className={props.required ? 'required' : ''}>
          <div style={{ width: '188px' }}>{props.label}</div>
        </Col>
        <Col
          md={{ size: 7, offset: 4 }}
          lg={{ size: 6, offset: 3 }}
          xl={{ size: 5, offset: 2 }}
        >
          {props.value}
        </Col>
      </Row>
      <Clearfix height={8} />
    </ItemValue>
  );
};

export default class SpeciesView extends React.Component {
  static propTypes = {
    initialValue: PropTypes.object,
    biodiversityID: PropTypes.string,
    speciesID: PropTypes.string,
  };

  handleDelete = () => {
    const { initialValue, history } = this.props;
    this.ConfirmElm.showConfirm({
      content: (
        <div>
          {`Bạn có muốn xóa tên loài: `}
          <b>{get(initialValue, 'SpeciesName.Name')}</b>
        </div>
      ),
      cb: async (value) => {
        if (value) {
          const res = await deleteOne(initialValue._id);
          if (res.success) {
            Message.success({ content: 'Thành Công' });
            history.push(slug.BIODIVERSITY.LIST);
          }
          if (res.error) Message.error({ content: res.message });
        }
      },
    });
  };

  render() {
    const { initialValue, getList } = this.props;
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <Clearfix height={8} />
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Icon
              style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
              icon={IconNames.CIRCLE_ARROW_LEFT}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
              onClick={getList}
            />

            <Permissions allowed={[`biodiversity.write`]}>
              <Fragment>
                <Clearfix width={8} />
                <Link to={slug.SPECIES.EDIT_WITH_ID + get(initialValue, '_id')}>
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.MANUALLY_ENTERED_DATA}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.PRIMARY}
                  />
                </Link>
              </Fragment>
            </Permissions>

            <Permissions allowed={[`biodiversity.delete`]}>
              <Fragment>
                <Clearfix width={8} />
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.BAN_CIRCLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={this.handleDelete}
                />
              </Fragment>
            </Permissions>
          </div>
        </HeaderContainer>
        <Clearfix height={8} />
        <SpeciesInfo>
          <ImagePart>
            <UploadImageComponent
              speciesID={this.props.speciesID}
              value={get(initialValue, 'AvatarUrl')}
            />
          </ImagePart>
          <InfoPart>
            <RowValue
              required
              label='Tên loài'
              value={get(initialValue, 'SpeciesName.Name')}
            />
            <RowValue
              required
              label='Mức độ bảo tồn'
              value={get(initialValue, 'SpeciesType.Name')}
            />
            <RowValue
              label='Tên địa phương'
              value={get(initialValue, 'LocalName')}
            />
            <RowValue
              label='Tên khoa học'
              value={get(initialValue, 'ScienceName')}
            />
            <RowValue label='Họ' value={get(initialValue, 'Surname.Name')} />
            <RowValue label='Bộ' value={get(initialValue, 'Set.Name')} />
            <RowValue
              label='Đặc điểm và giá trị loài'
              value={get(initialValue, 'CharacteristicsAndValues')}
            />
            <RowValue
              label='Mức độ bị đe dọa tuyệt chủng'
              value={get(initialValue, 'ExtinctionThreatLevel')}
            />
            <RowValue
              label='Chế độ quản lý, bảo vệ'
              value={get(initialValue, 'ManagementMode')}
            />
            <RowValue
              label='Đề xuất, kiến nghị'
              value={get(initialValue, 'Suggestion')}
            />
            <RowValue label='Ghi chú' value={get(initialValue, 'Notes')} />
            <RowValue
              label='Thêm vào'
              value={
                get(initialValue, 'AddedOn')
                  ? moment(get(initialValue, 'AddedOn')).format(
                      'DD/MM/YYYY HH:mm'
                    ) +
                    ' bởi ' +
                    get(initialValue, 'AddedBy')
                  : ''
              }
            />
            <RowValue
              label='Cập nhật lần cuối'
              value={
                get(initialValue, 'UpdatedOn')
                  ? moment(get(initialValue, 'UpdatedOn')).format(
                      'DD/MM/YYYY HH:mm'
                    ) +
                    ' bởi ' +
                    get(initialValue, 'UpdatedBy')
                  : ''
              }
            />
          </InfoPart>
        </SpeciesInfo>
        <AreaManagement speciesID={get(initialValue, '_id')} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/SpeciesView/index.js